module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "homepage js-x-scroll-catch"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.posts) ? _c('div', {
    key: "true",
    staticClass: "c-posts-wrapper js-x-scroll-target-md"
  }, [_c('posts-cover', {
    attrs: {
      "content": _vm.homepage
    }
  }), _vm._v(" "), _c('posts-list', {
    attrs: {
      "posts": _vm.posts
    },
    on: {
      "ready": function($event) {
        _vm.scrollListener()
      }
    }
  })], 1) : _c('div', {
    key: "false"
  }, [_c('loading-animation')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc0c458e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Homepage.vue
// module id = 88
// module chunks = 0